import React from 'react';
import AdminDocuments from '@/pages/admin/AdminDocuments';
import { kasirNav } from '@/lib/navConfig';

/**
 * Halaman Cetak Dokumen untuk role Kasir.
 * Sama persis dengan AdminDocuments tetapi menggunakan sidebar Kasir.
 * Backend endpoints (print PDF, kelola batch SJ, dot matrix) sudah accept role kasir.
 */
export default function KasirDocuments() {
  return <AdminDocuments nav={kasirNav} title="Cetak Dokumen (SO / Surat Jalan / Invoice)" />;
}
